export enum WatermarkTemplates {
  Standard_Duplicated = "Standard_Duplicated",
  Large_Centered = "Large_Centered",
  Standard_Top_Right = "Standard_Top_Right",
}
